module.exports = __webpack_public_path__ + "static/media/ico-player-home.3d90263a.svg";